module.exports = __webpack_public_path__ + "static/img/tuomasi.17ba9687.png";